import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CoolingOffComponent } from './cooling-off.component';
import { IonicModule } from '@ionic/angular';
import { ReactiveFormsModule } from '@angular/forms';
import { ComponentsModule } from 'src/app/components/components.module';



@NgModule({
  declarations: [
    CoolingOffComponent
  ],
  imports: [
    CommonModule,
    IonicModule,
    ReactiveFormsModule,
    ComponentsModule
  ],
  exports:[
    CoolingOffComponent
  ]
})
export class CoolingOffModule { }
